<template>
  <div class="user-list">
    <div class="headings">
      <div class="main-headings">
        <div class="heading heading-user" @click="onToggleSort('name')">
          <h3>{{$t('user')}}</h3>
          <div v-if="sortKey === 'name'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
        <div class="heading heading-status" @click="onToggleSort('deactivated')">
          <h3>Status</h3>
          <div v-if="sortKey === 'deactivated'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="heading heading-actions"></div>
    </div>

    <ul class="list-wrapper custom-scrollbar-light">
      <li v-for="user in sortedUsers" :key="user.id">
        <div class="content-wrapper">
          <div class="main-info">
            <p class="name">{{ user.name }} <span class="text-muted"  v-if="isMe(user.id)">(You)</span></p>
            <p class="text-small text-muted">{{ user.username }}</p>
          </div>

          <div class="status-info text-muted text-small">
            <p v-if="user.deactivated" class="deactivated">{{$t("users.us-status-deactive")}}</p>
            <p v-else class="active">{{$t("users.us-status-active")}}</p>
          </div>
        </div>

        <div class="actions"> 
          <button  v-if="!isMe(user.id)" class="btn-rounded-tertiary btn-flex" @click="toggleUserStatus(user.id, user.deactivated)">
            <span>
              <i class="fa-light fa-pen"></i>
            </span>
            {{ user.deactivated ? $t("users.us-status-activate") : $t("users.us-status-deactivate") }}
          </button>
        </div>
      </li>
    </ul>

    <div class="list-footer">
      <p class="text-small text-muted">{{ $t("users.users-count") }} {{ users.length }}</p>
    </div>
  </div>
</template>

<script>
import ConfirmModal from "@/components/modals/ConfirmModal";
import orderBy from "lodash/orderBy";
export default {
  data() {
    return {
      sortKey: "name",
      descending: false,
      succes: false
    };
  },

  props: {
    users: Array
  },
  methods: {
    onToggleSort(sortKey) {
      this.descending = this.sortKey == sortKey ? !this.descending : false;
      this.sortKey = sortKey;
    },

    toggleUserStatus(id, deactivated) {
      if (deactivated) {
        this.activateUser(id);
      } else {
        this.deactivateUser(id);
      }
    },

    activateUser(data) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("users.us-list-confirm-activate-title"),
          description: this.$t("users.us-list-confirm-activate"),
          confirmButtonText: this.$t("users.us-list-confirm-deactivate-yes"),
          onConfirm: (result) => {
            this.$store.dispatch("activateUser", data).then(() => {
            
            });
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    },
    deactivateUser(data) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("users.us-list-confirm-deactivate-title"),
          description: this.$t("users.us-list-confirm-deactivate"),
          confirmButtonText: this.$t("users.us-list-confirm-deactivate-yes"),
          onConfirm: (result) => {
            this.$store.dispatch("deactivateUser", data).then(() => {
             
            });
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    },
    
    isMe(id) {
      return id === this.$store.state.user.id;
    }

  },
  computed: {
    sortedUsers() {
      return orderBy(this.users || [], (user) => user[this.sortKey].toString().toLowerCase(), [
        this.descending ? "desc" : "asc"
      ]);
    }
  }
};
</script>
<style lang="less">
.user-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: clamp(100px, 100%, 80vh);
  overflow: hidden;
  background: #fff;
  border-radius: var(--standard-border-radius);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
 
  .headings {
    display: none;
  }
  .list-wrapper {
    overflow: auto;
    max-height: calc(80vh - 110px);
  }
  ul {
    padding: 12px 0 0 0;
    list-style-type: none;
    li {
      margin: 8px 20px;
      border-bottom: 1px solid var(--charcoal-20);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;

      .content-wrapper {
        .main-info {
          flex-grow: 1;
          .name {
            margin-bottom: 8px;
          }
        }
        .status-info {
          // justify-self: flex-end;
        }
      }
      .actions {
        width: 170px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .list-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 18px 20px;
    border-top: 1px solid var(--charcoal-20);
    p {
      margin-bottom: 0;
    }
  }
}

@media screen and (min-width: 768px) {
  .user-list {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    .headings {
      display: flex;
      flex-grow: 1;
      border-bottom: 1px solid var(--charcoal-20);
      padding: 14px 20px;
    }
    .main-headings {
      flex-grow: 1;
      display: grid;
      grid-template-columns: minmax(auto, 75%) auto;

      .heading {
        cursor: pointer;
        display: flex;
        gap: 8px;
        align-items: center;
        h3 {
          color: var(--charcoal-75);
          margin-bottom: 0;
        }
      }

      .heading-user {
        flex-grow: 1;
      }
      .heading-status {
        width: 120px;
        display: flex;
        justify-content: flex-start;
      }
    }
    .heading-actions {
      width: 170px;
      display: flex;
      justify-content: flex-end;
    }

    ul {
      li {
        .content-wrapper {
          display: grid;
          grid-template-columns: minmax(auto, 75%) auto;
          flex-grow: 1;
          align-items: center;

          .status-info {
            width: 120px;
            display: flex;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}
</style>
